import { CForm } from './CForm.js';
import { CFormCheck } from './CFormCheck.js';
import { CFormFeedback } from './CFormFeedback.js';
import { CFormFloating } from './CFormFloating.js';
import { CFormInput } from './CFormInput.js';
import { CFormLabel } from './CFormLabel.js';
import { CFormRange } from './CFormRange.js';
import { CFormSelect } from './CFormSelect.js';
import { CFormSwitch } from './CFormSwitch.js';
import { CFormText } from './CFormText.js';
import { CFormTextarea } from './CFormTextarea.js';
import { CInputGroup } from './CInputGroup.js';
import { CInputGroupText } from './CInputGroupText.js';

const CFormPlugin = {
    install: (app) => {
        app.component(CForm.name, CForm);
        app.component(CFormCheck.name, CFormCheck);
        app.component(CFormFeedback.name, CFormFeedback);
        app.component(CFormFloating.name, CFormFloating);
        app.component(CFormInput.name, CFormInput);
        app.component(CFormLabel.name, CFormLabel);
        app.component(CFormRange.name, CFormRange);
        app.component(CFormSelect.name, CFormSelect);
        app.component(CFormSwitch.name, CFormSwitch);
        app.component(CFormText.name, CFormText);
        app.component(CFormTextarea.name, CFormTextarea);
        app.component(CInputGroup.name, CInputGroup);
        app.component(CInputGroupText.name, CInputGroupText);
    },
};

export { CForm, CFormCheck, CFormFeedback, CFormFloating, CFormInput, CFormLabel, CFormPlugin, CFormRange, CFormSelect, CFormSwitch, CFormText, CFormTextarea, CInputGroup, CInputGroupText };
//# sourceMappingURL=index.js.map
